import axios from "axios";
import { Message } from "element-ui";
import router from "../router";
// import store from '../store/index'
// console.log(baseURL)
const baseURL = process.env.VUE_APP_SERVER_URL
// const baseURL = "https://xcx.b-chem.com/" // 正式环境
// const baseURL = "https://test.b-chem.com"; // 测试环境
// const baseURL = "http://10.39.18.121:8001";

//创建axios实例对象
const service = axios.create({
  baseURL, //后台api基准地址
  timeout: 600000,
});

//设置请求拦截器
service.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] =
      "Bearer " + localStorage.getItem("token") || "";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//设置响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response;
    if (res.data.code == '008' || res.data.code == '007' || res.data.code == '005') {
      Message.error({ message: res.data.message, duration: 2000 })
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      setTimeout(() => {
        router.push('/')
      }, 1500)
    }
    return res;
  },
  (error) => {
    Promise.reject(error);
  }
);

export default service;
